// extracted by mini-css-extract-plugin
export default {"title__text":"qnp9X","title__heading":"lmz3g","appear-from-above":"WdluP","appearFromAbove":"WdluP"};